//リサイズ中はtrantionを発動させない
let resizeTimer;
window.addEventListener("resize", () => {
  var touch_event = window.ontouchstart;
  var touch_points = navigator.maxTouchPoints;

  if (touch_event !== undefined && 0 < touch_points) {
  } else {
    document.body.classList.add("resize-animation-stopper");
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.body.classList.remove("resize-animation-stopper");
    }, 400);
  }
});

//外部リンクはblankで開く
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

//フッターを最後に読み込む
jQuery(function ($) {

  $('.main-footer, .footer-accordion').show();

});

//json確認
(() => {
  if (!document.querySelector('.pre-json')) return;
  class BuetifyPreJson {
    constructor(obj) {
      this.elms = document.querySelectorAll(`${obj.selector}`)
    }
    buetify() {
      [...this.elms].forEach(_elm => {
        const jsonText = _elm.textContent
        const jsonTextParse = JSON.parse(jsonText)
        _elm.textContent = JSON.stringify(jsonTextParse, null, 2)
      })
    }
    init() {
      this.buetify()
    }
  }
  const buetifyPreJson = new BuetifyPreJson({
    selector: '.pre-json',
  })
  buetifyPreJson.init()
})();

//アコーディオン
jQuery(function ($) {
  if ($('.accordion-group').length) {
    $('.accordion-group').each(function () {
      $(this).find($('.accordion-title a')).on('click', function () {
        var content = $(this).parent().parent().find($('.accordion-content'));
        $(this).parent().parent().toggleClass('active');
        content.slideToggle(150, 'linear');
      });
      $(this).find($('input[type="checkbox"]')).on('change', function () {
        var content = $(this).parent().parent().find($('.accordion-content'));
        $(this).parent().parent().toggleClass('active');
        content.slideToggle(150, 'linear');
      });
    });
  }
});

//アコーディオン（子階層場合）
jQuery(function ($) {
  if ($(".accordion-group-sub").length) {
    $(".accordion-group-sub").each(function () {
      $(this)
        .find($(".accordion-title a"))
        .on("click", function () {
          var content = $(this)
            .parent()
            .parent()
            .find($(".accordion-content-sub"));
          $(this).parent().parent().toggleClass("active");
          content.slideToggle(150, "linear");
        });

      $(this)
        .find($('input[type="checkbox"]'))
        .on("change", function () {
          var content = $(this)
            .parent()
            .parent()
            .find($(".accordion-content-sub"));
          $(this).parent().parent().toggleClass("active");
          content.slideToggle(150, "linear");
        });
    });
  }
});

/*-------------------------------
スクロールで隠れるヘッダー
-------------------------------*/
jQuery(function ($) {
  var startPos = 0, winScrollTop = 0;

  $(window).on('scroll', function () {
    var ww = $(window).width();
    winScrollTop = $(this).scrollTop();
    if (winScrollTop >= startPos) {
      if (winScrollTop >= 100) {
        $('header.main-header').addClass('hide');
      }
    } else {
      $('header.main-header').removeClass('hide');
    }

    if (winScrollTop <= 100) {
      $('.page-template-front-page').addClass('header-hide');
    } else {
      $('.page-template-front-page').removeClass('header-hide');
    }

    startPos = winScrollTop;
  });
});

/*-------------------------------
商品名を半角スペースでspanで区切る
-------------------------------*/

jQuery(function ($) {
  $('.product-list li h4 .title,.newline').each(function () {
    var title = $(this).html();
    var spl = title.split(' ');
    var ary = [];
    spl.forEach(
      function (value) {
        ary.push('<span>' + value + '</span>');
      }
    );

    result = ary.join(' ');
    $(this).html(result);
  });
});
